import api from './api';
import {setToken} from './servicesGetCookie';

export const PostFile = async(objPostFile) =>{
    const AUTH_TOKEN = setToken();
    const organizaBase64 = objPostFile[1].split(',');
    const resposta = await api.post(`PostFile`,{
            file_base64:`${organizaBase64[1]}`,
            filename:objPostFile[0].name,
            filesize:objPostFile[0].size.toString(),
            filetype:objPostFile[0].type,
        },{'headers':{'Authorization':`Bearer ${AUTH_TOKEN}`}} ).then((response)=>{
        return response.data;

    }).catch((error)=>{

            return error.response;

    })

    return resposta;
}
